import { OptInOutServices } from './interface';

export const BRAND_DOMAIN = window.location.hostname.indexOf('co.uk') !== -1 ?
                            window.location.hostname.split('.').slice(-3).join('.') :
                            window.location.hostname.split('.').slice(-2).join('.');

export const COOKIE_IDENTIFIER_UI_CONSENT = 'uiconsent';
export const COOKIE_IDENTIFIER_CONSENT_LEVEL = 'consentLevel';
export const COOKIE_IDENTIFIER_UICID = 'ui_cid';
export const COOKIE_IDENTIFIER_IDCC = 'idcc';

export const COOKIE_TRANSFER_REQUIRED = (/^https:\/\/(\w+\.)+?gmx\.(net|at|ch)\/.*$/i).test(document.location.href);
export const COOKIE_TRANSFER_SERVICE = {
  'gmx': 'https://dl.gmx.net/cookie-transfer/index.html',
  'gmxat': 'https://dl.gmx.at/cookie-transfer/index.html',
  'gmxch': 'https://dl.gmx.ch/cookie-transfer/index.html'
};

export const OPT_IN_SERVICES: OptInOutServices = {
  thirdParty: 'https://t.uimserv.net/mam_optin_p/',
  firstParty: {
    'web.de': 'https://ymprove.web.de/mam_optin_p/',
    'gmx.net': 'https://ymprove.gmx.net/mam_optin_p/',
    'gmx.at': 'https://ymprove.gmx.at/mam_optin_p/',
    'gmx.ch': 'https://ymprove.gmx.ch/mam_optin_p/',
    '1und1.de': 'https://ymprove.1und1.de/mam_optin_p/'
  }
};
export const OPT_OUT_SERVICES: OptInOutServices = {
  thirdParty: 'https://t.uimserv.net/mam_optout_p/',
  firstParty: {
    'web.de': 'https://ymprove.web.de/mam_optout_p/',
    'gmx.net': 'https://ymprove.gmx.net/mam_optout_p/',
    'gmx.at': 'https://ymprove.gmx.at/mam_optout_p/',
    'gmx.ch': 'https://ymprove.gmx.ch/mam_optout_p/',
    '1und1.de': 'https://ymprove.1und1.de/mam_optout_p/'
  }
};

export const OPT_IN_SERVICE_ADITION = 'https://ad11.adfarm1.adition.com/opt?m=optin&n=42';
